// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import ModalX from '../../common/svgs/ModalX';
import Handset from '../../common/svgs/Handset';
import Logout from '../../common/svgs/ProfileIcon';
import prettyPhone from '../../lib/prettyPhone';
import {get,isNil} from 'lodash';

@connect(state => ({
  user      : state.user,
  qs        : state.applicantProfile.qualifyingspecialist,
  labels    : get(state.labels, 'Common', {})
}), ({
  push
}))
export default class ApplicantMenu extends Component {
  static propTypes = {
    push      : PropTypes.func.isRequired,
    dispatch  : PropTypes.func.isRequired,
    user      : PropTypes.object.isRequired,
    qs        : PropTypes.object.isRequired,
    logOut    : PropTypes.func.isRequired,
    labels    : PropTypes.object.isRequired
  }

  constructor()
  {
    super();
  }

  state = {
    showSupportInfo: false
  }

  toggleQSInfo = () => {
    this.setState({
      showSupportInfo: !this.state.showSupportInfo
    });
  }

  hideQSInfo = () => {
    this.setState({
      showSupportInfo: false
    });
  }

  handleLogOut = () => {

    if (this.props.logOut) {
      this.props.logOut();
    }

  }

  renderSupport(state, props) {
    const {showSupportInfo} = state;
    const {qs} = props;

    if (showSupportInfo && qs) {
      return (

        <div className='support-qs-info' data-id='Modal'>
            <div className='header'>
              <div className='iconContent'>
                <a className='handset-icon' onClick={this.toggleQSInfo}>
                    <Handset  />
                    support
                </a>
              </div>
              <ModalX onClick={this.hideQSInfo} />
            </div>

            <div className='qs-content'>
                <span className='qs-name'>{props.qs.firstName} {props.qs.lastName}</span>
                <span className='qs-type'>Qualifying Specialist</span>
            </div>

            <div className='qs-info'>
                <span style={{whiteSpace: 'nowrap'}}>{props.qs.email}</span>
                <span>{prettyPhone(props.qs.directDial || '')}</span>
            </div>
        </div>

      );
    }
  }

  render() {
      return (
        <div className='applicant-menu'>
          <ul>
            {
              (!isNil(this.props.qs)) &&
              <li>
                <a className='handset-icon' data-id='support' onClick={this.toggleQSInfo}>
                  <Handset  />
                  support
                </a>
              </li>
            }
            <li>
              <a className='log-out-icon' onClick={() => this.handleLogOut()}>
                <Logout />
                 log out
              </a>
            </li>
          </ul>
          {
            this.renderSupport(this.state, this.props)
          }
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/f_applicantMenu/index.js